import * as React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import GlobalStyles from "@mui/joy/GlobalStyles";
import Avatar from "@mui/joy/Avatar";
import Box from "@mui/joy/Box";
import Divider from "@mui/joy/Divider";
import IconButton from "@mui/joy/IconButton";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import ListItemButton, { listItemButtonClasses } from "@mui/joy/ListItemButton";
import ListItemContent from "@mui/joy/ListItemContent";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";

import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CurrentExchangeRoundIcon from "@mui/icons-material/CurrencyExchangeOutlined";

// import ColorSchemeToggle from '../../utils/ColorSchemeToggle';
import { closeSidebar } from "../../utils";
import image from "../../constant/image";
import { logoutRequest, resetAppState } from "../../store/actions";
import {
  NAVIGATE_TO_DASHBOARD,
  NAVIGATE_TO_STAFFPAGE,
  NAVIGATE_TO_AGENTSPAGE,
  NAVIGATE_TO_TRANSACTIONPAGE,
  NAVIGATE_TO_ACCOUNTSPAGE,
  NAVIGATE_TO_APIACCESSPAGE,
  NAVIGATE_TO_APIUSAGEPAGE,
  NAVIGATE_TO_LOGSPAGE,
  NAVIGATE_TO_MERCHANTSPAGE,
  NAVIGATE_TO_MERCHANTVIEWPAGE,
  NAVIGATE_TO_INFOPAGE,
  NAVIGATE_TO_PARTNERSPAGE,
  NAVIGATE_TO_PARTNERVIEWPAGE,
  NAVIGATE_TO_STAFFVIEWPAGE,
  NAVIGATE_TO_AGENTVIEWPAGE,
  NAVIGATE_TO_AGENTSTAFFPAGE,
  NAVIGATE_TO_AGENTSTAFFVIEWPAGE,
  NAVIGATE_TO_ACCOUNTVIEWPAGE,
  NAVIGATE_TO_LIST_LOGS,
} from "../../route/types";
import { connect, useDispatch } from "react-redux";

import {
  FolderOutlined,
  GroupsOutlined,
  InfoOutlined,
  LinkOutlined,
  ManageAccountsOutlined,
  ReceiptLong,
  SpeedOutlined,
  StorefrontOutlined,
  SupportAgentOutlined,
} from "@mui/icons-material";

function Toggler({
  defaultExpanded = false,
  renderToggle,
  route,
  children,
}: {
  defaultExpanded?: boolean;
  children: React.ReactNode;
  route: boolean;
  renderToggle: (params: {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  }) => React.ReactNode;
}) {
  const [open, setOpen] = React.useState(defaultExpanded);

  React.useEffect(() => {
    // Set the initial state based on the condition
    setOpen(defaultExpanded || route);
  }, [defaultExpanded, route]);

  return (
    <React.Fragment>
      {renderToggle({ open, setOpen })}
      <Box
        sx={{
          display: "grid",
          gridTemplateRows: open ? "1fr" : "0fr",
          transition: "0.2s ease",
          "& > *": {
            overflow: "hidden",
          },
        }}
      >
        {children}
      </Box>
    </React.Fragment>
  );
}

const ListItemComponent = ({ route, action, props }) => {
  const navigate = useNavigate();

  const navTo = () => {
    // if (route === NAVIGATE_TO_STAFFPAGE) {

    //   action()
    // } else {
    navigate(route);
    // }

    action();
    // alert('i am navigate')
  };
  return (
    <ListItem>
      <ListItemButton
        role="menuitem"
        component="a"
        href={"#"}
        // selected={ location.pathname == route ? true : false}
        disabled={props.path ? true : false}
        sx={{
          backgroundColor: props.path ? "background.appcolor" : "transparent",
          boxShadow: props.path ? "sm" : "none",
          alignItems: "center",
        }}
        onClick={navTo}
      >
        <Box
          width={30}
          height={30}
          sx={{
            display: "flex",
            p: 1,
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 2,
            color: "white",
          }}
        >
          {props.icon}
        </Box>

        <ListItemContent>
          <Typography
            level="title-sm"
            sx={{ color: props.path ? "white" : null }}
          >
            {props.title}
          </Typography>
        </ListItemContent>

        {/* For Badge */}
        {/* <Chip size="sm" color="danger" variant="outlined">
      4
    </Chip> */}
      </ListItemButton>
    </ListItem>
  );
};

const DropdowmList = ({ children, props }) => {
  const location = useLocation();
  const LoanPath = () => {
    if (
      location.pathname === NAVIGATE_TO_APIACCESSPAGE ||
      location.pathname === NAVIGATE_TO_APIUSAGEPAGE ||
      location.pathname === NAVIGATE_TO_LOGSPAGE
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <ListItem nested>
      <Toggler
        route={LoanPath()}
        renderToggle={({ open, setOpen }) => (
          <ListItemButton
            onClick={() => setOpen(!open)}
            sx={{
              borderWidth: 0,
              borderLeftWidth: "3px",
              borderColor: LoanPath() ? "background.appcolor" : "transparent",
            }}
          >
            {props.icon}
            <ListItemContent>
              <Typography level="title-sm">{props.title}</Typography>
            </ListItemContent>
            <KeyboardArrowDownIcon
              sx={{ transform: open ? "rotate(180deg)" : "none" }}
            />
          </ListItemButton>
        )}
      >
        <List sx={{ gap: 0.5 }}>{children}</List>
      </Toggler>
    </ListItem>
  );
};

const Sidebar = ({ loginResult }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const logOut = () => {
    // navigate(NAVIGATE_TO_LOGINPAGE)
    dispatch(logoutRequest());
    dispatch(resetAppState());
    // dispatch(resetUserType());
  };

  //MAIN
  return (
    <Sheet
      className="Sidebar"
      sx={{
        position: { xs: "fixed", md: "fixed" },
        backgroundColor: "background.body",
        transform: {
          xs: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))",
          md: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))",
        },
        transition: "transform 0.4s ease, width 0.4s",
        zIndex: 10000,
        // height: "100dvh",
        minHeight: "100dvh",
        width: "var(--Sidebar-width)",
        top: 0,
        p: 2,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        borderRight: "1px solid",
        borderColor: "divider",
      }}
    >
      <GlobalStyles
        styles={(theme) => ({
          ":root": {
            "--Sidebar-width": "220px",
            [theme.breakpoints.up("lg")]: {
              "--Sidebar-width": "240px",
            },
          },
        })}
      />
      <Box
        className="Sidebar-overlay"
        sx={{
          position: "fixed",
          zIndex: 9998,
          top: 0,
          left: 0,
          width: "100vw",
          // height: "100vh",
          minHeight: "100vh",
          opacity: "var(--SideNavigation-slideIn)",
          backgroundColor: "var(--joy-palette-background-backdrop)",
          transition: "opacity 0.4s",
          transform: {
            xs: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1) + var(--SideNavigation-slideIn, 0) * var(--Sidebar-width, 0px)))",
            lg: "translateX(-100%)",
          },
        }}
        onClick={() => closeSidebar()}
      />

      {/* Logo and App name */}
      <Link to={NAVIGATE_TO_DASHBOARD} style={{ textDecoration: "none" }}>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <IconButton
            variant="soft"
            sx={{ backgroundColor: "transparent" }}
            size="sm"
          >
            <Avatar
              src={image.Images.icon}
              sx={{
                maxWidth: "32px",
                maxHeight: "32px",
                backgroundColor: "transparent",
              }}
            />
          </IconButton>
          <Typography level="title-lg">Open Pesa</Typography>
          {/* <ColorSchemeToggle sx={{ ml: 'auto' }} /> */}
        </Box>
      </Link>

      {/* Search Input if needed later */}
      {/* <Input size="sm" startDecorator={<SearchRoundedIcon />} placeholder="Search" /> */}

      <Box
        sx={{
          minHeight: 0,
          overflow: "hidden auto",
          // flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          [`& .${listItemButtonClasses.root}`]: {
            gap: 1.5,
          },
        }}
      >
        <List
          size="sm"
          sx={{
            gap: 1,
            "--List-nestedInsetStart": "30px",
            "--ListItem-radius": (theme) => theme.vars.radius.sm,
          }}
        >
          {/* home */}
          <ListItemComponent
            route={NAVIGATE_TO_DASHBOARD}
            action={() => null}
            props={{
              title: "Dashboard",
              icon: <SpeedOutlined />,
              path: location.pathname === NAVIGATE_TO_DASHBOARD ? true : false,
            }}
          />

          {/* Partners */}
          {/* Only admin can view partners */}
          {loginResult.role !== 3 &&
            (loginResult.role === 1 ? (
              <ListItemComponent
                route={NAVIGATE_TO_PARTNERSPAGE}
                action={() => null}
                props={{
                  title: "Manage Partners",
                  icon: <GroupsOutlined />,
                  path:
                    location.pathname === NAVIGATE_TO_PARTNERSPAGE ||
                    location.pathname === NAVIGATE_TO_PARTNERVIEWPAGE ||
                    location.pathname === NAVIGATE_TO_STAFFPAGE ||
                    location.pathname === NAVIGATE_TO_STAFFVIEWPAGE
                      ? true
                      : false,
                }}
              />
            ) : (
              // {/* Staff */} and only manager can view their partner staff
              <ListItemComponent
                route={NAVIGATE_TO_STAFFPAGE}
                action={() => null}
                props={{
                  title: "Manage Staffs",
                  icon: <ManageAccountsOutlined />,
                  partner_id: loginResult.owner_id,
                  path:
                    location.pathname === NAVIGATE_TO_STAFFPAGE ||
                    location.pathname === NAVIGATE_TO_STAFFVIEWPAGE
                      ? true
                      : false,
                }}
              />
            ))}

          {/* Merchants */}
          {/* Only admin can view merchants */}
          {loginResult.role === 1 && (
            <ListItemComponent
              route={NAVIGATE_TO_MERCHANTSPAGE}
              action={() => null}
              props={{
                title: "Manage Merchants",
                icon: <StorefrontOutlined />,
                path:
                  location.pathname === NAVIGATE_TO_MERCHANTSPAGE ||
                  location.pathname === NAVIGATE_TO_MERCHANTVIEWPAGE
                    ? true
                    : false,
              }}
            />
          )}

          {/* Agents */}
          <ListItemComponent
            route={NAVIGATE_TO_AGENTSPAGE}
            action={() => null}
            props={{
              title: "Manage Agents",
              icon: <ManageAccountsOutlined />,
              path:
                location.pathname === NAVIGATE_TO_AGENTSPAGE ||
                location.pathname === NAVIGATE_TO_AGENTVIEWPAGE ||
                location.pathname === NAVIGATE_TO_AGENTSTAFFPAGE ||
                location.pathname === NAVIGATE_TO_AGENTSTAFFVIEWPAGE
                  ? true
                  : false,
            }}
          />

          {/* Transactions */}
          <ListItemComponent
            route={NAVIGATE_TO_TRANSACTIONPAGE}
            action={() => null}
            props={{
              title: "Transactions",
              icon: <CurrentExchangeRoundIcon />,
              path:
                location.pathname === NAVIGATE_TO_TRANSACTIONPAGE
                  ? true
                  : false,
            }}
          />

          {/* Accounts */}
          {/* <ListItemComponent
            route={NAVIGATE_TO_ACCOUNTSPAGE}
            action={() => null}
            props={{
              title: "Accounts",
              icon: <FolderOutlined />,
              path:
                location.pathname === NAVIGATE_TO_ACCOUNTSPAGE ||
                location.pathname === NAVIGATE_TO_ACCOUNTVIEWPAGE
                  ? true
                  : false,
            }}
          /> */}

          {/* Intergration API */}
          <DropdowmList
            props={{ title: "Integration", icon: <LinkOutlined /> }}
          >
            {/* API Access */}
            <ListItemComponent
              route={NAVIGATE_TO_APIACCESSPAGE}
              action={() => null}
              props={{
                title: "OP API Access",
                icon: null,
                path:
                  location.pathname === NAVIGATE_TO_APIACCESSPAGE
                    ? true
                    : false,
              }}
            />

            {/* API Usage */}
            {/* {loginResult.role === 1 && (
              <ListItemComponent
                route={NAVIGATE_TO_APIUSAGEPAGE}
                action={() => null}
                props={{
                  title: "API Usage",
                  icon: null,
                  path:
                    location.pathname === NAVIGATE_TO_APIUSAGEPAGE
                      ? true
                      : false,
                }}
              />
            )} */}
          </DropdowmList>
        </List>

        <Divider sx={{ marginTop: "10px" }} />
        <List
          size="sm"
          sx={{
            mt: "auto",
            flexGrow: 0,
            "--ListItem-radius": (theme) => theme.vars.radius.sm,
            "--List-gap": "8px",
            mb: 2,
          }}
        >
          {/* <ListItem> */}
          {loginResult.role !== 1 && (
            <ListItemComponent
              route={NAVIGATE_TO_INFOPAGE}
              action={() => null}
              props={{
                title: "Info",
                icon: <InfoOutlined />,
                path: location.pathname === NAVIGATE_TO_INFOPAGE ? true : false,
              }}
            />
          )}
          {loginResult.role !== 3 && loginResult.role === 1 && (
            <ListItemComponent
              route={NAVIGATE_TO_LIST_LOGS}
              action={() => null}
              props={{
                title: "Logs",
                icon: <ReceiptLong />,
                path:
                  location.pathname === NAVIGATE_TO_LIST_LOGS ? true : false,
              }}
            />
          )}
          <ListItemComponent
            route="#"
            action={logOut}
            props={{
              title: "Log out",
              icon: <LogoutRoundedIcon />,
              path: null,
            }}
          />
        </List>
      </Box>
    </Sheet>
  );
};

const mapStateToProps = ({ auth }) => {
  const { otpResult: loginResult } = auth;

  return {
    loginResult,
  };
};

export default connect(mapStateToProps, {})(Sidebar);
// export default Sidebar
